const SECOND = 1e3;
const secondsToMs = (seconds) => seconds * SECOND;
export {
  secondsToMs
};
